import { Divider, Grid } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useMemo, useState } from 'react';
import { LuMegaphone } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import { IJob } from 'wisestep-api';
import { WsButton, WsColors, WsDataGrid, WsTypography, WsTypoVariants } from 'wisestep-base';

import CardWrapper from '../../../../features/automatedEmailCampaignSettings/childRoutes/CardWrapper';

const JobBoardPublishCard = ({ job }: { job: IJob }) => {
  const navigate = useNavigate();
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(50);

  const handlePage = (newPage: number) => setPage(newPage);

  const handlePageSize = (newPageSize: number) => {
    handlePage(0);
    setPageSize(newPageSize);
  };

  const data = useMemo(
    () =>
      (job?.jobBoardPosting ?? []).map((jobBoard, index) => ({
        id: index,
        jobBoardName: jobBoard?.jobBoardName ?? '',
      })),

    [job?.jobBoardPosting]
  );
  const columns: GridColDef[] = [
    {
      field: 'jobBoardName',
      headerName: 'Job Board',
      sortable: false,
      flex: 1,
      renderCell: (params) => <WsTypography>{params.value}</WsTypography>,
    },
  ];

  const navigateToPublish = () => navigate(`/jobs/${job.id}/publish`);
  return (
    <CardWrapper>
      <Grid container p={1} justifyContent="space-between" alignItems="center">
        <WsTypography variant={WsTypoVariants.SUB_TITLE} bold>
          Published on
        </WsTypography>
        <WsButton startIcon={<LuMegaphone />} size="small" onClick={navigateToPublish}>
          Publish More
        </WsButton>
      </Grid>
      <Divider sx={{ borderColor: WsColors.NEUTRAL_100 }} />
      <WsDataGrid
        autoHeight
        rows={data}
        columns={columns}
        paginationMode="client"
        page={page ?? 0}
        onPageChange={handlePage}
        pageSize={pageSize ?? 20}
        onPageSizeChange={handlePageSize}
      />
    </CardWrapper>
  );
};

export default JobBoardPublishCard;
